<div class="card height-100 custom-color p-shadow-9">
    <h5 class="centerText">Број скидања апликације по држави</h5>
    <p-chart [data]="countryChartData" [options]="pieChartOptions" type="doughnut" height="400px"></p-chart>
</div>
